import { createBrowserHistory } from 'history';
import qs from 'qs';
import { replaceInSearch } from '../../components/Filters/utils/replaceInSearch';
/**
  We need to keep the query string in sync with the current active filter state.
  updateQueryString() will set the query string for list filters only, for now
 *
 * @param activeFilters The full list of active filters from the client cache
 */
export function updateListFilterQueryString(activeFilters, history) {
    if (history === undefined) {
        history = createBrowserHistory();
    }
    const activeListFilters = activeFilters.listFilters;
    let queryString = '';
    if (activeListFilters.length === 0) {
        // No active filters, remove `list` from query string altogether
        queryString = qs.stringify({ list: null });
    }
    else {
        const params = { list: {} };
        activeListFilters.forEach((filter) => {
            params.list[filter.id] = filter.values;
        });
        queryString = qs.stringify(params, {
            encodeValuesOnly: true
        });
    }
    replaceInSearch({
        history,
        location: history.location,
        queryString,
        replaceType: true,
        routeType: 'filterChange'
    });
}
export function updateBooleanQueryString(activeFilters, history) {
    if (history === undefined) {
        history = createBrowserHistory();
    }
    const activeBoolFilters = activeFilters.booleanFilters;
    let queryString = '';
    if (activeBoolFilters.length === 0) {
        // No active filters, remove `bool` from query string altogether
        queryString = qs.stringify({ boolean: null });
    }
    else {
        const params = { boolean: {} };
        activeBoolFilters.forEach((filter) => {
            params.boolean[filter.id] = filter.value;
        });
        queryString = qs.stringify(params, {
            encodeValuesOnly: true
        });
    }
    replaceInSearch({
        history,
        location: history.location,
        queryString,
        replaceType: true,
        routeType: 'filterChange'
    });
}
export function updateRangeQueryString(activeFilters, history) {
    if (history === undefined) {
        history = createBrowserHistory();
    }
    const activeRangeFilters = activeFilters.rangeFilters;
    let queryString = '';
    if (activeRangeFilters.length === 0) {
        // No active filters, remove `range` from query string altogether
        queryString = qs.stringify({ range: null });
    }
    else {
        const params = { range: {} };
        activeRangeFilters.forEach((filter) => {
            params.range[filter.id] = [filter.min, filter.max];
        });
        queryString = qs.stringify(params, {
            encodeValuesOnly: true
        });
    }
    replaceInSearch({
        history,
        location: history.location,
        queryString,
        replaceType: true,
        routeType: 'filterChange'
    });
}
export function updateMultiListQueryString(activeFilters, history) {
    if (history === undefined) {
        history = createBrowserHistory();
    }
    const activeMultiFilters = activeFilters.multiListFilters;
    let queryString = '';
    if (activeMultiFilters.length === 0) {
        queryString = qs.stringify({ multiList: null });
    }
    else {
        const params = { multiList: {} };
        activeMultiFilters.forEach((filter) => {
            params.multiList[filter.id] = filter.values;
        });
        queryString = qs.stringify(params, {
            encodeValuesOnly: true
        });
    }
    replaceInSearch({
        history,
        location: history.location,
        queryString,
        replaceType: true,
        routeType: 'filterChange'
    });
}
//# sourceMappingURL=updateQueryString.js.map